import { request } from './http.js';
import AdminApi from "@/assets/js/AdminApi";
import AdminApi2 from "@/assets/js/AdminApi2";
export default {
    AdminApi:AdminApi.Service,
    AdminApi2:AdminApi2.Service
}


